import React from 'react';
import { Button } from '../ui/button';
import { Zap, ZapOff } from 'lucide-react';

const ReducedMotionToggle = ({ enabled, onChange }) => {
  return (
    <div className="flex items-center gap-3 bg-slate-900/50 rounded-lg p-3 border border-slate-700">
      <div className="flex-1">
        <p className="text-sm font-medium text-slate-100">Reduced Motion</p>
        <p className="text-xs text-slate-400 mt-0.5">
          Disable decorative animations for better accessibility
        </p>
      </div>
      <Button
        onClick={() => onChange(!enabled)}
        variant="outline"
        size="sm"
        className={`text-xs ${
          enabled
            ? 'bg-slate-700 border-slate-600'
            : 'bg-gold/100/20 border-gold/40 text-gold'
        }`}
      >
        {enabled ? (
          <>
            <ZapOff className="w-3 h-3 mr-1" />
            OFF
          </>
        ) : (
          <>
            <Zap className="w-3 h-3 mr-1" />
            ON
          </>
        )}
      </Button>
    </div>
  );
};

export default ReducedMotionToggle;
